"use client";

import { YEARLYSchedule } from "@/constants/constant-client";
import { useParams, useRouter, useSearchParams } from "next/navigation";
import { ChangeEvent, Suspense, useRef, useTransition } from "react";

const to0Pad = (x: number, n: number) => x.toString().padStart(n, "0");
const toYYYYMMDD = (d: Date) => `${d.getFullYear()}${to0Pad(d.getMonth() + 1, 2)}${to0Pad(d.getDate(), 2)}`;

export function Filter({ paramName }: { paramName: string }) {
  const [isPending, startTransition] = useTransition();
  const prevValue = useRef("");
  const router = useRouter();
  const { year } = useParams();
  const searchParams = useSearchParams();
  const game = searchParams.get(paramName);
  const start = `${game?.substring(0, 4)}-${game?.substring(4, 6)}-${game?.substring(6, 8)}`;
  const end = `${game?.substring(8, 12)}-${game?.substring(12, 14)}-${game?.substring(14, 16)}`;

  const schedule: (typeof YEARLYSchedule)[keyof typeof YEARLYSchedule] =
    String(year) in YEARLYSchedule ? (YEARLYSchedule as any)[String(year)] : undefined;

  const setQuery = (d: ChangeEvent<HTMLInputElement>) => {
    if (prevValue.current !== d.target.value) {
      startTransition(() => {
        const params = new URLSearchParams(searchParams.toString());
        const a = new Date(d.target.value);
        params.set(paramName, `${toYYYYMMDD(a)}${toYYYYMMDD(a)}9`);
        router.replace("?" + params.toString(), { scroll: false });
      });
    }
  };

  if (start !== end) return <input className="input input-sm" type="date" disabled />;

  return (
    <div className="flex">
      <input
        className={`input input-sm ${game ? "input-accent" : "input-secondary"}`}
        type="date"
        value={start}
        onChange={setQuery}
        min={schedule?.pennant?.start || undefined}
        max={schedule?.pennant?.end || undefined}
      />
      {isPending && <span className="loading loading-spinner loading-md"></span>}
    </div>
  );
}

export function DateFilter({ paramName }: { paramName: string }) {
  return (
    <Suspense
      fallback={
        <div className="flex">
          <input className="input input-sm" type="date" />
        </div>
      }
    >
      <Filter paramName={paramName} />
    </Suspense>
  );
}
